import { lazyLoad } from 'utils/loadable';

export const QuizRecordDetailPage = lazyLoad(
  () => import('./index'),
  module => module.QuizRecordDetailPage,
);
